<div class="modal__content">
    <h2>{{ $t('modals.lostpassword.title') }}</h2>
    <form class="form" @submit.prevent="activeValidation = true; onSubmit();">
        <form-alerts ref="formAlert"></form-alerts>
        <div class="form__group">
            <label>{{ $t('modals.login.email') }}</label>
            <input :class="{alert: errors.email && activeValidation}" :disabled='isSubmitting' name="email" type="text" :placeholder="$t('modals.login.email-placeholder')" v-model="email" autocorrect="off" autocapitalize="none" />
            <div class="form__group-alert" v-if="errors.email && activeValidation">{{ $t('modals.register.alerts.errorNoValidEmail') }}</div>
        </div>
        <div class="form__group">
            <button class="btn btn-full" :disabled='isSubmitting' type="submit">{{ $t('modals.lostpassword.changepassword') }}</button>
        </div>
    </form>
</div>
